<div class="container-product-detail my-3">
  <div class="d-flex justify-content-between">
    <div class="back-button-section">
      <button class="back-button" (click)="goBack()"><i class="fa fa-arrow-left" aria-hidden="true"></i> Back</button>
    </div>
    <!-- <button class="btn btn-dark btn-sm" (click)="goBack()"><i class="fa-solid fa-arrow-left"></i> Back</button> -->
    <button style="height: fit-content" *ngIf="productData?.appUser?.regionName || productData?.type == 'promote'"
      class="btn btn-dark btn-sm">
      {{ productData?.type == "promote" ? (productData?.subRegionName ?? "Doorstep") : productData?.appUser?.regionName
      }}
    </button>
  </div>
  <app-breadcrumb *ngIf="productData" [data]="[
      {
        name: productData.categoryName,
        link: '/category/' + (productData.categorySlug ?? productData.categoryName.toLowerCase().replaceAll(' ', '-')),
        active: false,
      },
      {
        name: productData.name,
        link: '/product/' + productData.slug,
        active: true,
      },
    ]"></app-breadcrumb>
  <div [class.product-page]="!isLoading">
    @if (!isLoading) {
    @if (!isOnMobile) {
    <div class="d-flex flex-column">
      <app-product-types-list [productId]="productData?.id" [categoryId]="productData?.categoryId" *ngIf="typesExist"
        (typesExist)="typesExist = $event; realignSwiperIndexWhenTabsChange()"></app-product-types-list>
      <div style="width: 1" *ngIf="!typesExist"></div>

      <app-forum-list [forums]="productForums" (reloadForums)="loadForums()" [pageId]="productData?.id"
        type="product"></app-forum-list>


    </div>

    <div *ngIf="productData != null; else notFound">
      <app-view-product-details [addProductComponent]="addProductComponent" [productData]="productData"
        [linkRfererUserId]="linkRfererUserId"></app-view-product-details>
    </div>
    <div class="d-flex flex-column justify-content-between faq-edit-your-product-container">
      <app-product-faq-list [additionalFAQS]="productData?.faqInfos" [categoryId]="productData?.categoryId"
        *ngIf="faqsExist" (faqsExist)="faqsExist = $event"></app-product-faq-list>
      <div style="width: 1" *ngIf="!faqsExist"></div>
      <!---
         span style="font-size: .8rem;">If you are the Product</span>
          <span></span>
      -->
      <div class="mt-2" *ngIf="isLogin && productData?.shoutContact == '65' + userPhoneNumber">
        <button class="btn btn-success d-flex flex-column justify-content-center align-items-center">
          <span style="font-size: 1.2rem" (click)="editCurrentProduct()">Edit Your Product</span>
        </button>
      </div>
      <div class="mt-2 position-relative w-100 d-flex justify-content-end" *ngIf="!isLogin && showLoginWizard">
        <div class="shadow p-4 position-absolute wizard-msg">
          <button class="t-btn close-btn" (click)="showLoginWizard = false"><i class="fa fa-x"></i></button>
          If you are the owner of owner of this service, you can login to edit your product. Ensure that you login using
          the same phone number being used for this service provided.
          <button style="color: var(--secondary)" class="t-btn" (click)="openLoginModal()">Login to edit my
            product</button>
        </div>
        <img src="../../../../../assets/images/w.jpeg" class="shadow login-wizard" />
      </div>
    </div>
    } @else {
    <app-my-carousel-swiper class="product-mobile-swiper" (onSwiper)="initSwiper($event)" [config]="carOptions">
      <div class="swiper-slide" *ngIf="typesExist || isUserAnAdmin || productForums?.length">
        <app-product-types-list [productId]="productData?.id"
          (typesExist)="typesExist = $event; realignSwiperIndexWhenTabsChange()"
          [categoryId]="productData?.categoryId"></app-product-types-list>

        <app-forum-list [forums]="productForums" (reloadForums)="productForums()" [pageId]="productData?.id"
          type="product"></app-forum-list>


        <!-- <button (click)="openForumAdd()" *ngIf="isUserAnAdmin" class="mt-2 btn btn-sm btn-outline-primary">Add Forum +</button> -->
      </div>

      <div class="swiper-slide">
        <div *ngIf="productData != null; else notFound">
          <app-view-product-details [addProductComponent]="addProductComponent" [productData]="productData"
            [linkRfererUserId]="linkRfererUserId"></app-view-product-details>
        </div>
      </div>
      <div class="swiper-slide" *ngIf="faqsExist">
        <app-product-faq-list [additionalFAQS]="productData?.faqInfos" [categoryId]="productData?.categoryId"
          *ngIf="faqsExist" (faqsExist)="faqsExist = $event"></app-product-faq-list>
      </div>
    </app-my-carousel-swiper>
    }
    <ng-template #notFound>
      <div class="not-found-container">
        <img src="assets/images/no-found-products.png" alt="No Products" class="img-fluid mb-4" />
        <h1>404 - Not Found</h1>
        <p>The page or product you are looking for does not exist.</p>
      </div>
    </ng-template>
    } @else {
    <div class="loading-container mx-auto"><i class="fa-solid fa-spinner fa-spin"></i> Loading...</div>
    }
  </div>
</div>
<app-add-shop *ngIf="enableMemberShop && productData" #AddShop [enableMemberShop]="enableMemberShop"
  [isSingleProduct]="true"></app-add-shop>